export const defaultOptions = {
  UserSetProperties2: null,
  ImportNewEntities: true,
  // 011...1101  length 27
  ImportNewOptions: 67108861, // bit mask indicating all options selected except mark as paused
  ImportNewLabelsAndAssociations: true,
  ImportNewCustomFiltersForShoppingCampaigns: true,
  UpdateEntityPreferences: {
    ImportUpdatedEntities: true,
    // 1111..1111 length 35
    ImportUpdateOptions: 34359738367, // bit mask indicating all available options selected
  },
  UpdateLabelsAndAssociations: true,
  UpdateCustomFiltersForShoppingCampaigns: true,
  ImportDeletedEntities: false,
  DefaultBidsBelowMinToAdCenterMinBid: true,
  DefaultCampaignBudgetBelowMinToAdCenterMinBudget: true,
  RaiseLowBidsToMinServingBidsForBsc: true,
  AppendDestUrlPreference: {
    UseAppendString: false,
    AppendStringForDestinationUrl: '',
  },
  SearcAndReplaceDestUrlPreference: {
    UseSearchAndReplaceString: false,
    SearchStringForDestinationUrl: '',
    ReplaceStringForDestinationUrl: '',
  },
  AppendTrackingTemplatePreference: {
    UseAppendString: false,
    AppendStringForTrackingTemplate: '',
  },
  SearchAndReplaceTrackingTemplatePreference: {
    UseSearchAndReplaceString: false,
    SearchStringForTrackingTemplate: '',
    ReplaceStringForTrackingTemplate: '',
  },
  SearchAndReplaceForCustomParameters: {
    EnableSearchAndReplace: false,
    IgnoreCaseInPlainText: true,
    ReplaceString: '',
    SearchString: '',
    UseRegularExpression: false,
  },
  SearchAndReplaceForFinalURLSuffix: {
    EnableSearchAndReplace: false,
    IgnoreCaseInPlainText: true,
    ReplaceString: '',
    SearchString: '',
    UseRegularExpression: false,
  },
  StoreIdForImportedProductAdExtensions: null,
  ImportSearchAndDsaMixedCampaignAsSearchCampaign: false,
};
